<template>
    <div class="h-100">
        <md-card-media class="card-hackathon-banner">
            <img :src="card.banner ? card.banner : bannerPlaceholder" />
        </md-card-media>
        <md-card-content class="hackathon-card">
            <img :src="card.logo ? card.logo : logoPlaceholder" class="hackathon-logo" />
            <h2 class="hackathon-name">{{card.name}}</h2>
            <h4>
                <div class="hackathon-organizer">Organized by <strong>{{card.organizer_name}}</strong></div>
            </h4>
        </md-card-content>
    </div>
</template>
<script>
export default {
    name: "CommunityCard",
    props: ["card"],
    data: () => ({
        logoPlaceholder: "/img/logo-default.png"
    }),
    computed: {
        conf() {
            return this.$store.getters.conf;
        },
        bannerPlaceholder() {
            return (
                "/img/banner-default/" +
                (Math.floor(Math.random() * 5) + 1) +
                ".jpg"
            );
        }
    }
};
</script>
<style lang="scss">
@import "@/assets/scss/_common.scss";
.card-hackathon-banner {
    img {
        height: 180px;
        object-fit: cover;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        -webkit-border-top-left-radius: 5px;
        -webkit-border-top-right-radius: 5px;
        -moz-border-radius-topleft: 5px;
        -moz-border-radius-topright: 5px;
    }
}
.hackathon-card {
    // text-align: center;
    height: calc(100% - 180px);
    display: flex;
    flex-direction: column;
    &.md-card-content {
        padding: 25px 21px 25px 25px;
        .topic:first-child {
            margin-left: 0;
        }
    }
    .btn {
        font-size: 14px;
        width: 48% !important;
    }
    .hackathon-logo {
        width: 100px;
        height: 100px;
        border: solid 4px #ffffff;
        background-color: #ffffff;
        position: absolute;
        border-radius: 50%;
        // left: calc(50% - 54px);
        left: 25px;
        top: -54px;
        object-fit: cover;
    }

    .hackathon-name {
        margin-top: 26px;
        font-size: 22px;
        font-weight: 600;
        color: $palette-blue;
    }

    h4 {
        .hackathon-organizer {
            margin-right: 5px;
            color: #969696;
            margin-top: 11px;
            font-size: 16px;
        }
    }

    .topic {
        margin: 3px;
        font-size: 16px;
        color: $palette-blue;
    }
}

.wrap-info-btn-manage {
    .txt-status-card {
        color: $palette-blue;
        font-size: 13px;
    }

    .status-label {
        font-size: 15px;
        font-weight: 700;
        color: #fff;
        padding: 2px 10px;
        display: inline-block;
        border-radius: 4px;
        margin-top: 4px;
        background-color: #ff5c00;
        text-transform: capitalize;

        &.active {
            background-color: #087505;
        }
        &.pending {
            background-color: #e19626;
        }
        &.inactive {
            border: 2px solid #417505;
        }
        &.hidden {
            border: 2px dashed darkgray;
            background: #e5e5e5;
            color: darkgray;
        }
    }
}
</style>
